import React from "react";

import { SiSpinrilla } from "react-icons/si";

const LoadableButton = ({ title, loading, onClick, isSubmit, disabled, color = 'blue', className }) => {
  if (loading) {
    return <button type="button" disabled="" className={`${className} cursor-not-allowed py-2 px-4 flex justify-center items-center opacity-70 bg-${color}-600 hover:bg-${color}-700 focus:ring-${color}-500 focus:ring-offset-${color}-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg `}>
      <SiSpinrilla size={18} className="mr-2 animate-spin"/>
      { title }
    </button>
  }
  return (
    <button
      disabled={disabled}
      onClick={onClick}
      type={isSubmit ? "submit" : "button"}
      className={`${disabled && "opacity-70 cursor-not-allowed"} ${className} py-2 px-4  bg-${color}-600 hover:bg-${color}-700 focus:ring-${color}-500 focus:ring-offset-${color}-200 text-white w-full transition ease-in duration-200 text-center text-base font-semibold shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2  rounded-lg`}
    >
      { title }
    </button>
  );
}

export default LoadableButton


